module.exports = __webpack_public_path__ + "static/img/item-point.dcf75030.png";